import React from 'react';

export default function SpectatorOverlay({ spectatorCount = 0, onLeave }) {
  return (
    <>
      {/* Top banner */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
        background: 'linear-gradient(135deg, #1e293b, #0f172a)',
        borderBottom: '2px solid #7c3aed',
        padding: '8px 16px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 14 }}>👁️</span>
          <span style={{ color: '#c4b5fd', fontSize: 13, fontWeight: 600 }}>
            Spectating
          </span>
          <span style={{ color: '#8b949e', fontSize: 11 }}>
            (30s delay)
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {spectatorCount > 0 && (
            <span style={{ color: '#8b949e', fontSize: 11 }}>
              {spectatorCount} watching
            </span>
          )}
          <button onClick={onLeave} style={{
            background: 'transparent', border: '1px solid #30363d', color: '#8b949e',
            padding: '4px 12px', borderRadius: 6, fontSize: 11, cursor: 'pointer'
          }}>
            Leave
          </button>
        </div>
      </div>
    </>
  );
}
